module.exports = __webpack_public_path__ + "static/antd-card-inner-8798c1e2c48c04541429d34a17925b9d.png";